<template>
    <div class="configurator-accessories container">
        <MainTitle :title="$t('accessories.mainTitle')" id="accessories" />
        <BikePicture :url="bikeImage" />
    
        <div v-for="item in groupData">
            <selectCheckbox :title="item.Title" :characteristic="item.Category" :options="item.Value.SelectedCheckbox" />
        </div>
    </div>
</template>


<script>
    // @ is an alias to /src
    import MainTitle                from '@/components/MainTitle.vue'
    import BikePicture              from '@/components/BikePicture.vue'
    import SelectCheckbox           from '@/components/SelectCheckbox.vue'

    export default {
        name: 'accessories',
        components: {
            MainTitle,
            BikePicture,
            SelectCheckbox
        },
        data() {
            return {
                groupData: [],
                bikeImage: '',
                page: 'accessories',
            }
        },
        methods: {
            // get groupdata from api (accessories)
            async getGroupDataAccessories() {
                let app = this;
                let parent = app.$parent;
                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', parent.ConfigurationID);
                params.append('CustomerID', parent.customerID);
                parent.popupError = false;

                await app.getGroupDataAccessoriesPost(app,parent,params);
            },
            getGroupDataAccessoriesPost(app,parent,params) {
                this.$http.post(this.$apiurl + '/api/GetGroupData/Zubehoer', params)
                    .then(response => {
                        app.groupData = response.data['ReturnData'];
                        for(let i = 0; i < app.groupData.length; i++) {
                            if(app.$i18n.locale == 'de') {
                                app.groupData[i].Title = app.groupData[i].Category;
                            } else {
                                app.groupData[i].Title = app.groupData[i].Description;
                            }
                        }


                        app.bikeImage = response.data['TransferData']['Image'];
                        if(response.data['TransferData']['Price'])  app.$parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.priceSymbol;
                        parent.loading = false;
                    })
                    .catch(error => {
                        app.getGroupDataAccessoriesPost(app,parent,params);
                    })
            }
        },
        mounted() {
            if(!this.$parent.ConfigurationID)
            {
                this.$router.push({ path: '/' })
            } else {
                this.$parent.loading = true;
                this.getGroupDataAccessories();
                this.$parent.nav = true;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-accessories {
        margin-bottom: 200px;
    }
</style>